import {
	CategoryScale,
	Chart as ChartJS,
	Legend,
	LineElement,
	LinearScale,
	PointElement,
	Title,
	Tooltip
} from 'chart.js';

import { useTranslation } from 'react-i18next';

import BaseChart, { CHART_TYPES } from './BaseChart';
import * as S from './styled/LineChart.styled';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

/**
 * @typedef {object} LineChartProps
 * @property {object} data - The data to display
 * @property {boolean} loading - The loading state
 * @property {string} xTitle - The title of the x axis
 * @property {string} yTitle - The title of the y axis
 *
 * data example:
 * {
 *     labels: ['label1', 'label2'], // the labels should come already translated
 *    datasets: [
 *       {
 *          label: 'label1',
 *          data: [10, 20],
 *      }
 *  ]
 * }
 */

const LineChartV2 = ({ data, loading, xTitle, yTitle }) => {
	const { t } = useTranslation();
	const options = {
		interaction: {
			mode: 'index',
			intersect: false
		},
		plugins: {
			legend: {
				position: 'top',
				onHover: (_, legendItem) => {
					document.body.style.cursor = legendItem ? 'pointer' : 'default';
				},
				onLeave: () => {
					document.body.style.cursor = 'default';
				}
			}
		},
		scales: {
			x: {
				title: {
					display: xTitle !== '',
					text: t(xTitle)
				}
			},
			y: {
				title: {
					display: yTitle !== '',
					text: t(yTitle)
				}
			}
		},
		aspectRatio: 2
	};

	return (
		<S.Container>
			<BaseChart
				type={CHART_TYPES.line}
				options={options}
				data={{
					labels: loading ? [t('loading')] : data?.labels,
					datasets: data ? data.datasets : [{ data: [0] }]
				}}
			/>
		</S.Container>
	);
};

export default LineChartV2;
